import React from "react"
import { Col, Typography } from "antd"
import style from "./Footer.module.scss"

export default () => (
  <Col className={style.copyrightColumn} span={24}>
    <Typography.Text className={style.copyrightText}>
      &copy; {new Date().getFullYear()} Lantern Lodge Asheville Biltmore
      Village. All Rights Reserved.
    </Typography.Text>
    <img
      alt="The StaySRG - Southern Resort Group logo"
      src="/StaySRG-full-white.svg"
      style={{
        maxWidth: 100,
        marginBottom: 16,
        opacity: 0.75,
        width: `90vw`,
      }}
    />
  </Col>
)
